import React from "react";

import styles from "./gateways-list.module.scss";
import { GatewaysListBody } from "@src/components/molecules/gateways-list-body/gateways-list-body";
import { GatewayWithSourceViewStateTypes } from "../../../../../common/types/gateways-list-types";
export interface GatewaysListPropTypes {
  data: GatewayWithSourceViewStateTypes[];
  description: string;
  state: "Connected" | "Disconnected";
}

const cssClassName = "gateways-list";

export const GatewaysList = ({
  data,
  description,
  state,
}: GatewaysListPropTypes) => {
  return (
    <table className={styles[cssClassName]}>
      <tbody className={styles[`${cssClassName}__body`]}>
        <GatewaysListBody data={data} description={description} state={state} />
      </tbody>
    </table>
  );
};
